import type {ReactNode} from 'react';
import {DismissableLayerBranch} from 'ch3-ui-lib';

/**
 * Keeps call UI usable while an app dialog is open.
 *
 * A modal dialog switches off pointer events on <body> and closes when you click outside it. The call surface
 * (Start a call pill, dialer, call bubbles, group stage, toasts) floats above every page, so it must still take
 * clicks and drags then (e.g. move the pill, hang up) without closing the dialog underneath.
 * `display: contents` keeps the wrapper out of the layout; pointer-events still inherit through it.
 */
export const CallLayer = ({children}: { children: ReactNode }) => (
    <DismissableLayerBranch className="contents" style={{pointerEvents: 'auto'}} data-testid="call-layer">
        {children}
    </DismissableLayerBranch>
);
